import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actionCreators from "../../actionCreators/index.js";
import TpHeader from "./tpHeader";

function mapStateToProps(state) {
  return {
    userDetails: state.userDetails,
    businessActivities: state.businessActivities,
    loadingValue: state.loadingValue,
    machines: state.machines,
    isSimulateMode: state.isSimulateMode,
    simulatedBusinessActivities: state.simulatedBusinessActivities,
    simulatedUserDetails: state.simulatedUserDetails,
    dealerAccount: state.dealerAccount,
    texts: state.translatedTexts,
    transactionAttachmentResponse : state.transactionAttachmentResponse,
    relatedAccount: state.relatedAccount
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(TpHeader);
